var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCncParts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 1.8335C2.31296 1.8335 1.97382 1.97397 1.72378 2.22402C1.47373 2.47407 1.33325 2.81321 1.33325 3.16683V9.8335H2.66659V3.16683H9.33325V1.8335H2.66659ZM5.33325 4.50016C4.97963 4.50016 4.64049 4.64064 4.39044 4.89069C4.14039 5.14074 3.99992 5.47987 3.99992 5.8335V12.5002H5.33325V5.8335H11.9999V4.50016H5.33325ZM13.3333 8.50016V13.8335H7.99992V8.50016H13.3333ZM13.3333 7.16683H7.99992C7.6463 7.16683 7.30716 7.30731 7.05711 7.55735C6.80706 7.8074 6.66658 8.14654 6.66658 8.50016V13.8335C6.66658 14.1871 6.80706 14.5263 7.05711 14.7763C7.30716 15.0264 7.6463 15.1668 7.99992 15.1668H13.3333C13.6869 15.1668 14.026 15.0264 14.2761 14.7763C14.5261 14.5263 14.6666 14.1871 14.6666 13.8335V8.50016C14.6666 8.14654 14.5261 7.8074 14.2761 7.55735C14.026 7.30731 13.6869 7.16683 13.3333 7.16683Z",
    fill: "#474949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCncParts);
export default __webpack_public_path__ + "static/media/cncParts.a109b425363c91a90121c262b9ef3ba3.svg";
export { ForwardRef as ReactComponent };